import {EditorState, StateEffect, StateField} from '@codemirror/state'
import {EditorView} from '@codemirror/view'

/** Effect that will be triggered when mouse button is pressed or lifted. The goal here is to keep track of whether
 * the user's mouse is currently down, as we don't want to cause layout shifts fromm recalculating active blocks and
 * thus showing more delimiters until the user releases the mouse to finish their selection.*/
const mousedownChangeEffect = StateEffect.define<boolean>()

const mousedownObserver = EditorView.domEventObservers({
  mousedown: (_, view) => {
    // The mouse could move outside the boundaries of the editor before being released
    view.dom.ownerDocument.addEventListener(
      'mouseup',
      () => {
        view.dispatch({effects: mousedownChangeEffect.of(false)})
      },
      {once: true, capture: true},
    )

    view.dispatch({effects: mousedownChangeEffect.of(true)})
  },
})

/** Field to store the mousedown state on the editor state. */
const isMousedownField = StateField.define<boolean>({
  create: () => false,
  update: (prev, transaction) => transaction.effects.find(eff => eff.is(mousedownChangeEffect))?.value ?? prev,
  provide: () => [mousedownObserver],
})

/** Extension that tracks when the user actively has their mouse pressed in the editor. */
export const mousedownExtension = [isMousedownField]

/** Get the mousedown state from the editor state. Throws an error if `mousedownExtension` is not installed. */
export function isMousedown(state: EditorState) {
  return state.field(isMousedownField)
}
